import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotifyConfig } from '../models/notify-config.model';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  notificationsSubject: BehaviorSubject<NotifyConfig[]> = new BehaviorSubject([]);
  notificationsActionSubject: BehaviorSubject<NotifyConfig> = new BehaviorSubject(undefined);

  show(config: NotifyConfig): void {
    const newMessage: NotifyConfig = {
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      duration: 5000,
      withAlertIcon: true,
      ...config,
      message: Array.isArray(config.message) ? config.message : [config.message],
    };
    this.notificationsSubject.next([...this.notificationsSubject.getValue(), newMessage]);
    this.setTimerForMessage(newMessage.duration);
  }

  showAction(config: NotifyConfig): Observable<NotifyConfig> {
    const newMessage: NotifyConfig = {
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      duration: 5000,
      withAlertIcon: true,
      ...config,
      message: Array.isArray(config.message) ? config.message : [config.message],
    };
    this.notificationsSubject.next([...this.notificationsSubject.getValue(), newMessage]);
    this.setTimerForMessage(newMessage.duration);

    return this.notificationsActionSubject;
  }

  onClose(index: number): void {
    this.notificationsSubject.getValue().splice(index, 1);
  }

  onAction(item: NotifyConfig): void {
    this.notificationsActionSubject.next(item);
  }

  private setTimerForMessage(duration: number): void {
    setTimeout(() => {
      this.notificationsSubject.next(
        this.notificationsSubject.getValue().slice(1, this.notificationsSubject.getValue().length),
      );
      this.notificationsActionSubject.next(undefined);
    }, duration);
  }
}
